import { gql, useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Input, Select } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { CURRENCIES } from "../consts";

const CREATE_PRICE_LIST = gql`
  mutation ($company: String!, $name: String!, $currency: String) {
    createPriceList(company: $company, name: $name, currency: $currency) {
      priceList {
        id
        name
        currency
      }
    }
  }
`;

const SAVE_PRICE_LIST = gql`
  mutation ($id: ID!, $name: String!, $currency: String) {
    savePriceList(id: $id, name: $name, currency: $currency) {
      priceList {
        id
        name
        currency
      }
    }
  }
`;

const EditPriceListView = ({
  id,
  initialCompany = "AB",
  initialName = "",
  initialCurrency = "USD",
  initialOdooId = null,
  complete,
}) => {
  const [company, setCompany] = useState(initialCompany);
  const [name, setName] = useState(initialName);
  const [currency, setCurrency] = useState(initialCurrency);
  const [odooId, setOdooId] = useState(initialOdooId);
  const [createPriceList, createPriceListRes] = useMutation(CREATE_PRICE_LIST, {
    variables: { company, name, currency, odooId },
    refetchQueries: ["FETCH_PRICE_LISTS"],
    awaitRefetchQueries: true,
    onCompleted(res) {
      Alert("success", "Price List Created.");
      complete(res.createPriceList.priceList, "CREATED");
    },
    onError(error) {
      Alert("error", error.message);
    },
  });
  const [savePriceList, savePriceListRes] = useMutation(SAVE_PRICE_LIST, {
    variables: { id, name, currency, odooId },
    refetchQueries: ["FETCH_PRICE_LISTS"],
    awaitRefetchQueries: true,
    onCompleted(res) {
      Alert("success", "Price List Saved.");
      complete(res.savePriceList.priceList);
    },
    onError(error) {
      Alert("error", error.message);
    },
  });

  return (
    <div className="space-y-10">
      <div className="space-y-4 text-base">
        <div className="flex space-x-3 items-center">
          <label htmlFor="">Company: </label>
          <Select value={company} onChange={(e) => setCompany(e.target.value)}>
            <option value="AB">AB</option>
            <option value="LTD">LTD</option>
          </Select>
        </div>
        <div className="flex space-x-3 items-center">
          <label htmlFor="">Name: </label>
          <Input
            className="w-full"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="flex space-x-3 items-center">
          <label htmlFor="">Currency: </label>
          <Select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
          >
            {CURRENCIES.map((currency) => (
              <option key={currency} value={currency}>
                {currency}
              </option>
            ))}
          </Select>
        </div>

        <div className="text-xs opacity-70 italic">
          To connect with Odoo Price list, you will need to choose an existing
          price list from Odoo. Create one if you have not. Not that each price
          list in wis could only be connected to one price list in Odoo.
        </div>
      </div>

      <div className="text-lg">
        {id ? (
          <Button
            primary
            onClick={savePriceList}
            loading={savePriceListRes.loading}
          >
            Save
          </Button>
        ) : (
          <Button
            primary
            onClick={createPriceList}
            loading={createPriceListRes.loading}
          >
            Save
          </Button>
        )}
      </div>
    </div>
  );
};

export default EditPriceListView;
